<template>
    <div class="container">
        <h1 class="page-title h1 mt-4">Sieci</h1>

        <div v-if="!userStoresLoading">
            <page-preloader mode="wrapper">
                <div>
                    <user-stores-section
                        tableName="ableToJoinStores"
                        title="Sklepy, które można dołączyć do Sieci"
                        @rowSelectChange="
                            (data) =>
                                onRowSelectChange({ mode: 'join', ...data })
                        "
                        :tableData="ableToJoinStoresTableData"
                        areAllItemsSelectedGetterName="areAllAbleToJoinStoresSelected"
                        selectAllItemsDispatchName="selectAllAbleToJoinStores"
                        unSelectAllItemsDispatchName="unselectAllAbleToJoinStores"
                        itemsGetterName="getAbleToJoinStores"
                    />
                    <the-btn
                        v-if="ableToJoinStores.length > 0"
                        :disabled="
                            ableToJoinSelectedStores &&
                            !ableToJoinSelectedStores.length
                        "
                        :text="'Dodaj wszystkie zaznaczone sklepy'"
                        :btnClass="'btn btn-outline-custom'"
                        @click.native="addStoresToNetwork"
                    ></the-btn>
                </div>
            </page-preloader>

            <div>
                <page-preloader
                    mode="wrapper"
                    :is-loading="activationCancelRequestIsPending"
                >
                    <user-stores-section
                        title="Sklepy, dla których można anulować aktywację w Sieci"
                        tableName="ableToActivationCancelStores"
                        @rowSelectChange="
                            (data) =>
                                onRowSelectChange({
                                    mode: 'activationCancel',
                                    ...data,
                                })
                        "
                        :tableData="ableToActivationCancelStoresTableData"
                        areAllItemsSelectedGetterName="areAllAbleToActivationCancelStoresSelected"
                        selectAllItemsDispatchName="selectAllAbleToActivationCancelStores"
                        unSelectAllItemsDispatchName="unselectAllAbleToActivationCancelStores"
                        itemsGetterName="getAbleToActivationCancelStores"
                    />
                    <the-btn
                        v-if="ableToActivationCancelStores.length > 0"
                        :disabled="
                            ableToActivationCancelSelectedStores &&
                            !ableToActivationCancelSelectedStores.length
                        "
                        :text="'Anuluj zaznaczone aktywacje'"
                        :btnClass="'btn btn-outline-custom'"
                        @click.native="cancelStoresActivation"
                    ></the-btn>
                </page-preloader>
            </div>

            <div>
                <page-preloader
                    mode="wrapper"
                    :is-loading="disconnectRequestIsPending"
                >
                    <user-stores-section
                        title="Sklepy, które można odłączyć od Sieci"
                        tableName="ableToDisconnectStores"
                        @rowSelectChange="
                            (data) =>
                                onRowSelectChange({
                                    mode: 'disconnect',
                                    ...data,
                                })
                        "
                        :tableData="ableToDisconnectStoresTableData"
                        areAllItemsSelectedGetterName="areAllAbleToDisconnectStoresSelected"
                        selectAllItemsDispatchName="selectAllAbleToDisconnectStores"
                        unSelectAllItemsDispatchName="unselectAllAbleToDisconnectStores"
                        itemsGetterName="getAbleToDisconnectStores"
                    />
                    <the-btn
                        v-if="ableToDisconnectStores.length > 0"
                        :disabled="
                            ableToDisconnectSelectedStores &&
                            !ableToDisconnectSelectedStores.length
                        "
                        :text="'Odłącz zaznaczone sklepy'"
                        :btnClass="'btn btn-outline-danger btn-sm'"
                        @click.native="disconnectStores"
                    ></the-btn>
                </page-preloader>
            </div>
        </div>
        <div v-else>Ładowanie...</div>
    </div>
</template>

<script>
import {
    UserStoresSection,
    UserStoreTableMainButton
} from '../../components/userStores'
import PagePreloader from '../../components/global/ui/PagePreloader.vue'

export default {
    components: {
        UserStoresSection,
        PagePreloader
    },
    computed: {
        ableToActivationCancelSelectedStores() {
            return (
                this.$store.getters.getAbleToActivationCancelStores &&
                this.$store.getters.getAbleToActivationCancelStores.filter(
                    store => store.checked
                )
            )
        },
        ableToDisconnectSelectedStores() {
            return (
                this.$store.getters.getAbleToDisconnectStores &&
                this.$store.getters.getAbleToDisconnectStores.filter(
                    store => store.checked
                )
            )
        },
        ableToJoinSelectedStores() {
            return (
                this.$store.getters.getAbleToJoinStores &&
                this.$store.getters.getAbleToJoinStores.filter(
                    store => store.checked
                )
            )
        },
        userStoresLoading() {
            return this.$store.getters.getStoresLoadingState
        },
        ableToJoinStores() {
            if (!this.$store.getters.getAbleToJoinStores) return []
            return this.$store.getters.getAbleToJoinStores.map(e => {
                e.disabled =
                    e.statusInNetwork === 'accept' ||
                    e.statusInNetwork === 'request'
                return e
            })
        },
        ableToDisconnectStores() {
            if (!this.$store.getters.getAbleToDisconnectStores) return []
            return this.$store.getters.getAbleToDisconnectStores
        },
        ableToActivationCancelStores() {
            if (!this.$store.getters.getAbleToActivationCancelStores) return []
            return this.$store.getters.getAbleToActivationCancelStores
        },
        ableToJoinStoresTableData() {
            const head = ['Nazwa', 'Adres sklepu', 'Status ']
            const body = this.ableToJoinStores.map(item => {
                return [
                    {
                        text: item.shopName,
                        style: { 'font-size': '1.15em', 'font-weight': '500' },
                        customClass: item.disabled
                            ? 'text-gray'
                            : 'text-primary'
                    },
                    {
                        text: item.shopAddress,
                        style: { 'font-size': '0.85em' }
                    },
                    item.statusName,
                    {
                        type: 'hidden',
                        data: { id: item.shopId, disabled: item.disabled }
                    },
                    {
                        type: 'component',
                        component: UserStoreTableMainButton,
                        mode: 'action',
                        config: {
                            disabled: item.disabled,
                            text: 'Zaakceptuj',
                            onClick: () => this.singleItemJoinToNetwork(item)
                        }
                    }
                ]
            })
            const customRowStyle = 'font-size:0.875rem'
            return { head, body, customRowStyle }
        },
        ableToDisconnectStoresTableData() {
            const head = ['Nazwa', 'Adres sklepu', 'Sieć', 'Status']
            const body = this.ableToDisconnectStores.map(item => {
                return [
                    {
                        text: item.shopName,
                        style: { 'font-size': '1.15em', 'font-weight': '500' }
                    },
                    {
                        text: item.shopAddress,
                        style: { 'font-size': '0.85em' }
                    },
                    {
                        type: 'hidden',
                        data: { id: item.shopId, disabled: item.disabled }
                    },
                    { text: `${item.networkId}, ${item.networkName}` },
                    item.statusName,
                    {
                        type: 'component',
                        component: UserStoreTableMainButton,
                        mode: 'action',
                        config: {
                            text: 'Odłącz',
                            onClick: () => this.singleItemDisconnect(item)
                        }
                    }
                ]
            })
            const customRowStyle = 'font-size:0.875rem'
            return { head, body, customRowStyle }
        },
        ableToActivationCancelStoresTableData() {
            const head = ['Nazwa', 'Adres sklepu', 'Sieć', 'Status']
            const body = this.ableToActivationCancelStores.map(item => {
                return [
                    {
                        text: item.shopName,
                        style: { 'font-size': '1.15em', 'font-weight': '500' }
                    },
                    {
                        text: item.shopAddress,
                        style: { 'font-size': '0.85em' }
                    },
                    {
                        type: 'hidden',
                        data: { id: item.shopId, disabled: item.disabled }
                    },
                    { text: `${item.networkId}, ${item.networkName}` },
                    item.statusName,
                    {
                        type: 'component',
                        component: UserStoreTableMainButton,
                        mode: 'action',
                        config: {
                            text: 'Anuluj',
                            onClick: () => this.singleItemActivationCancel(item)
                        }
                    }
                ]
            })
            const customRowStyle = 'font-size:0.875rem'
            return { head, body, customRowStyle }
        }
    },
    data() {
        return {
            activationCancelRequestIsPending: false,
            disconnectRequestIsPending: false
        }
    },
    methods: {
        async singleItemActivationCancel(item) {
            await this.$store.dispatch(
                'unselectAllAbleToActivationCancelStores'
            )
            await this.$store.dispatch(
                'toggleAbleToActivationCancelStoreSelectedState',
                { id: item.id, checked: true }
            )
            this.cancelStoresActivation()
        },
        async singleItemDisconnect(item) {
            await this.$store.dispatch('unselectAllAbleToDisconnectStores')
            await this.$store.dispatch(
                'toggleAbleToDisconnectStoreSelectedState',
                { id: item.id, checked: true }
            )

            this.disconnectStores()
        },
        async singleItemJoinToNetwork(item) {
            await this.$store.dispatch('toggleAbleToJoinStoreSelectedState', {
                id: item.id,
                checked: true
            })
            this.addStoresToNetwork()
        },
        async cancelStoresActivation() {
            this.activationCancelRequestIsPending = true
            try {
                await this.$store.dispatch(
                    'cancelOrDisconnectStores',
                    this.ableToActivationCancelSelectedStores
                )
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zgłoszenie zostało przyjęte'
                })
                this.onSuccessfullyDeactivateOrDisconnect()
            } catch (err) {
                this.handleCancelOrDisconnectRequestError(err)
            } finally {
                this.activationCancelRequestIsPending = false
            }
        },
        async disconnectStores() {
            this.disconnectRequestIsPending = true
            try {
                await this.$store.dispatch(
                    'cancelOrDisconnectStores',
                    this.ableToDisconnectSelectedStores
                )
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content:
                        'Zgłoszenie odłączenia sklepów z sieci zostało przyjęte'
                })
                this.onSuccessfullyDeactivateOrDisconnect()
            } catch (err) {
                this.handleCancelOrDisconnectRequestError(err)
            } finally {
                this.disconnectRequestIsPending = false
            }
        },
        handleCancelOrDisconnectRequestError(err) {
            let notificationMessage = 'Wystąpił błąd. Spróbuj ponownie później.'

            if (err.message === 'someRejected') {
                this.onSuccessfullyDeactivateOrDisconnect()
                notificationMessage =
                    'Uwaga! Nie wszystkie działania skończyły się sukcesem'
            }

            this.$store.dispatch('addNotification', {
                type: 'danger',
                content: notificationMessage
            })
        },
        async onSuccessfullyDeactivateOrDisconnect() {
            await this.$store.dispatch('resetUserStoresState')
            this.$scrollTo(top, 400)
            this.$store.dispatch('storesFetch')
        },
        addStoresToNetwork() {
            this.$store.dispatch('openModal', {
                component: 'AddStoresToNetwork'
            })
        },
        onRowSelectChange(data) {
            let dispatchName = ''
            if (data.mode === 'join') {
                dispatchName = 'toggleAbleToJoinStoreSelectedState'
            } else if (data.mode === 'disconnect') {
                dispatchName = 'toggleAbleToDisconnectStoreSelectedState'
            } else if (data.mode === 'activationCancel') {
                dispatchName = 'toggleAbleToActivationCancelStoreSelectedState'
            }

            this.$store.dispatch(dispatchName, {
                id: data.id,
                checked: data.selected
            })
        }
    }
}
</script>